import React from 'react';
import { X, Trash2, Calendar, Clock, User } from 'lucide-react';
interface SettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDeleteClick: () => void;
  analysisData: any;
}
const SettingsModal: React.FC<SettingsModalProps> = ({
  isOpen,
  onClose,
  onDeleteClick,
  analysisData
}) => {
  if (!isOpen) return null;
  // Format date
  const formatDate = (dateString: string) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" data-id="element-1157">
      <div className="relative w-full max-w-md mx-auto bg-white rounded-lg shadow-lg p-6" data-id="element-1158">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700" data-id="element-1159">
          <X size={20} data-id="element-1160" />
        </button>
        <h3 className="text-xl font-semibold mb-6 text-gray-900" data-id="element-1161">
          Configurações do Relatório
        </h3>
        <div className="space-y-4" data-id="element-1162">
          <h4 className="text-lg font-medium text-gray-900" data-id="element-1163">
            Informações do Relatório
          </h4>
          <div className="space-y-3" data-id="element-1164">
            <div className="flex items-start" data-id="element-1165">
              <Calendar size={18} className="text-gray-700 mt-0.5 mr-2" data-id="element-1166" />
              <div data-id="element-1167">
                <p className="text-sm text-gray-700 font-medium" data-id="element-1168">
                  Data de criação
                </p>
                <p className="font-medium text-gray-900" data-id="element-1169">
                  {formatDate(analysisData.createdAt)}
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-1170">
              <Clock size={18} className="text-gray-700 mt-0.5 mr-2" data-id="element-1171" />
              <div data-id="element-1172">
                <p className="text-sm text-gray-700 font-medium" data-id="element-1173">
                  Última atualização
                </p>
                <p className="font-medium text-gray-900" data-id="element-1174">
                  {formatDate(analysisData.updatedAt)}
                </p>
              </div>
            </div>
            {analysisData.metadata?.usuario && <div className="flex items-start" data-id="element-1175">
                <User size={18} className="text-gray-700 mt-0.5 mr-2" data-id="element-1176" />
                <div data-id="element-1177">
                  <p className="text-sm text-gray-700 font-medium" data-id="element-1178">
                    Criado por
                  </p>
                  <p className="font-medium text-gray-900" data-id="element-1179">
                    {analysisData.metadata.usuario.nome || analysisData.metadata.usuario.email}
                  </p>
                </div>
              </div>}
          </div>
          <div className="border-t border-gray-200 pt-4 mt-4" data-id="element-1180">
            <h4 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1181">Ações</h4>
            <button onClick={onDeleteClick} className="w-full px-4 py-2 bg-red-50 text-red-600 rounded-md hover:bg-red-100 flex items-center justify-center" data-id="element-1182">
              <Trash2 size={16} className="mr-2" data-id="element-1183" />
              Excluir relatório
            </button>
          </div>
        </div>
        <div className="mt-6 flex justify-end" data-id="element-1184">
          <button onClick={onClose} className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200" data-id="element-1185">
            Fechar
          </button>
        </div>
      </div>
    </div>;
};
export default SettingsModal;